// 首页CID
export const HomePageCid = 'c_waimai_c_overseas_aatucy3n';

export const MarketingBannerItemMv = 'b_waimai_c_overseas_bm9ltrr5_mv';

export const MarketingBannerItemMc = 'b_waimai_c_overseas_bm9ltrr5_mc';
